(function () {
  'use strict';

  /* @ngdoc object
   * @name events.vehicles.deposits.edit
   * @description
   *
   */
  angular
    .module('events.vehicles.deposits.edit', [
      'ui.router'
    ]);
}());
